import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("灰色栏位请联系商务进行开通")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle ms-2 fs-7" }, null, -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("灰色栏位请联系商务进行开通")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle ms-2 fs-7" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("智能选品")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("手动定制")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("智能选品为灰色请联系商务进行开通")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle ms-2 fs-7" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("强制推广")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("柔性推广")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("柔性推广：如果商品相关性在前top N内（N为阈值），则推广，否则不推广")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle ms-2 fs-7" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("请输入1~最大上限间的整数")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("首页上限500，列表页上限500，详情页上限100")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle ms-2 fs-7" }, null, -1)
const _hoisted_21 = {
  key: 3,
  style: {"display":"flex"}
}
const _hoisted_22 = { key: 4 }
const _hoisted_23 = { key: 5 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("规则配置")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("手动配置")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 请输入初始推广位置 ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" (1~10)，及每隔 ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" (数字)位置推广商品。 ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("上一步")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("下一步")
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("选品规则：")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("以下是详细商品及位置配置结果：")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("规则配置：初始推广位置")
const _hoisted_36 = { style: {"color":"red","font-weight":"bold","padding":"0 10px"} }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("，及每隔")
const _hoisted_38 = { style: {"color":"red","font-weight":"bold","padding":"0 10px"} }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("位置推广商品。")
const _hoisted_40 = { class: "dialog-footer" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("关闭")

import {MenuComponent} from "@/assets/ts/components";
import {setCurrentPageBreadcrumbs} from "@/core/helpers/breadcrumb";
import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import Datatable from "@/components/kt-datatable/Datatable2.vue";
import ApiService from "@/core/services/ApiService";
import {ElMessage} from 'element-plus';
import SelectionRule from "@/components/selection-item/SelectionRule.vue";
import EnterGoodsId from "@/components/selection-item/EnterGoodsId.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const dataT = ref<HTMLElement | null>(null);
const apiUrl = 'recommend/programme';
const tableHeader = ref([
  {
    name: "ID",
    key: "id",
    width: 50
  },
  {
    name: "名称",
    key: "name",
  },
  {
    name: "商品类目",
    key: "category",
    sortable: true,
  },
  {
    name: "区域",
    key: "area",
    width: 50
  },
  {
    name: "选品类型",
    key: "selection_type_name",
  },
  {
    name: "投放类型",
    key: "recommend_type_name",
  },
  {
    name: "阈值",
    key: "threshold",
    width: 50
  },
  {
    name: "维护人",
    key: "user"
  },
  {
    name: "开始时间",
    key: "start_time",
  },
  {
    name: "结束时间",
    key: "stop_time",
  },
  {
    name: "创建时间",
    key: "create_time",
  },
  {
    name: "更新时间",
    key: "update_time",
  },
]);
const filters = reactive({
  search: '',
  page_id: 1
});
const formData = reactive({
  id: 0,
  name: '',
  page_id: 0,
  area: '',
  category_id: 0,
  selection_type: 2,
  goods_count: 100,
  sorting_key_id: 0,
  start_time: '',
  stop_time: '',
  dimension: [] as any[],
  rules: [] as any[],
  position_type: 1,
  initial: 1,
  interval: 1,
  recommend_type: 1,
  threshold: 100,
  input_type: 1,
  goods: [] as any[],
});
const start_stop_time = ref<any>([
    formData.start_time,
    formData.stop_time
]);

const validateNameExist = function(rule, value, callback) {
  let name = '';
  (dataT as any).value.tableData.some((item)=>{
    name = item.name;
    return item.id == formData.id;
  });
  if (value === '') {
    callback(new Error('请输入名称！'))
  } else if (formData.id == 0 || (formData.id > 0 && value != name)) {
    ApiService.get(apiUrl + '/exist', {name: value}).then(({data}) => {
      if (data == true) callback(new Error('该名称已存在！'))
      else callback()
    })
  } else {
    callback()
  }
};
const validatePositions = (rule, value, callback) => {
  if (formData.input_type === 1) {
    if (value.length == 0) {
      callback(new Error('请先填入商品ID和位置关系！'));
    } else {
      let goods_ids = [] as Array<string>;
      let positions = [] as Array<string>;
      for (let v of value) {
        if (v.goods_id == '') {
          callback(new Error('商品ID不能为空！'));
        } else if (goods_ids.indexOf(v.goods_id) > -1) {
          callback(new Error('商品ID:' + v.goods_id + ' 重复！'));
        } else if (positions.indexOf(v.position) > -1) {
          callback(new Error('商品位置:' + v.position + ' 有多个商品！'));
        } else {
          goods_ids.push(v.goods_id);
          positions.push(v.position);
        }
      }
    }
  }
  callback();
};
const validateStartStopTime = (rule, value, callback) => {
  if (start_stop_time.value == null) {
    start_stop_time.value = [
      formData.start_time,
      formData.stop_time
    ];
  }
  formData.start_time = start_stop_time.value[0];
  formData.stop_time = start_stop_time.value[1];
  if (formData.start_time == '' || formData.stop_time == '') {
    callback(new Error('请输入起止时间！'));
  } else if (formData.stop_time <= formData.start_time) {
    callback(new Error('结束时间必须晚于开始时间！'));
  }
  callback();
};
const rules = {
  name: [
    { required: true, message: '请输入名称！', trigger: 'blur' },
    { validator: validateNameExist, trigger: 'blur' },
  ],
  page_id: [
    { required: true, message: '请选择栏位', trigger: 'change' }
  ],
  category_id: [
    { required: true, message: '请选择类目', trigger: 'change' }
  ],
  start_stop_time: [
    { validator: validateStartStopTime, trigger: 'blur' },
  ],
  goods: [
    { validator: validatePositions, trigger: 'blur' },
  ],
};

const config = reactive({
  config: {} as any,  //模块配置
  area: [] as any[],  //站点区域配置
  category: [] as any[],  //站点栏目类目配置
  page: [] as any[],  //栏位
  dimension: [] as any[],  //站点维度配置
  attrs: {} as any,  //站点维度属性配置
  sorting_key: [] as any[],  //站点排序
});
const thresholdLimit = ref(500);  //栏位的阈值最大值
const step = ref(1);  //当前步骤
const maxStep = ref(2);  //最多步骤
const goodsData = ref<any>({});  //选品商品结果
const goodsTotal = ref(0);  //选品商品数量
const loading = ref(false);  //选品载入
const callback = ref<any>(null);  //提交回调方法
const dialogResult = ref(false);  //结果弹框
const result = ref<any>({});  //当前结果值
// 分页
const pagination = reactive({
  page: 1,
  total: 0,
  pageSize: 20,
});
const defaultExpanded = ref<Array<any>>([]); //默认展开的节点
const dselect = {
  "in": '包含',
  "not in": '不包含',
  "gt": "大于",
  "lt": "小于",
  "gte,lt": "介于区间",
  "gte": "大于等于",
  "lte": "小于等于"
};
const enterGoodsRef = ref<HTMLElement | null>(null);  //手动输入商品ID组件

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("recommend.programme", ["recommend.name"]);
  if (filters.page_id == 1) {
    if (tableHeader.value[2].key == 'category') {
      tableHeader.value.splice(2, 1);
    }
  } else {
    if (tableHeader.value[2].key != 'category') {
      tableHeader.value.splice(2, 0, {
        name: "商品类目",
        key: "category",
        sortable: true,
      })
    }
  }

  if ((dataT as any) != undefined) (dataT as any).value.btnLoading = true;
  ApiService.get(apiUrl + '/config').then(({data}) => {
    if (data.page.length < 1) {
      ElMessage.error('基础数据不足，请与管理员联系！');
    } else {
      config.config = data.config;
      config.page = [...data.page];
      if (!config.page.some((p) => {return p.is_active == true})) {
        ElMessage.error('基础数据不足，请与管理员联系！');
      } else if (config.config.selection_enabled == 1 && (data.sorting_key.length < 1)) {
        ElMessage.error('基础数据不足，请与管理员联系！');
      } else {
        config.sorting_key = [...data.sorting_key];
        if ((dataT as any) != undefined) (dataT as any).value.btnLoading = false;
      }
    }
  });
});

const loadDimension = function() {
  if (config.config.selection_enabled == 1) {
    if (config.dimension.length < 1 || Object.keys(config.attrs).length < 1){
      ApiService.get(apiUrl + '/dimension').then(({data}) => {
        if (config.config.selection_enabled == 1 && (data.dimension.length < 1 || Object.keys(data.attrs).length < 1)) {
          ElMessage.error('基础数据不足，请与管理员联系！');
        } else {
          let treeData: Array<any> = []
          for (let d of data.dimension) {
            let children: Array<any> = []
            for (let c of d.children) {
              children.push({
                id: c.dimension_id + ':' + c.dimension_name + ':' + c.dimension_field + ':' + c.cat_id + ':' + c.cat_name + ':' + c.dtype,
                label: c.dimension_name,
              })
            }
            treeData.push({
              id: d.cat_id,
              label: d.cat_name,
              disabled: true,
              children: children
            })
          }
          config.dimension = [...treeData];
          config.attrs = data.attrs;
          if (defaultExpanded.value.length < 1) defaultExpanded.value.push(config.dimension[0].id)
        }
      });
    } else {
      if (defaultExpanded.value.length < 1) defaultExpanded.value.push(config.dimension[0].id)
    }
    if (formData.sorting_key_id == 0) formData.sorting_key_id = config.sorting_key[0].key_id;
  }
}

const add = function() {
  formData.page_id = filters.page_id;
  start_stop_time.value = [formData.start_time, formData.stop_time]
  step.value = 1;
  maxStep.value = 2;
  defaultExpanded.value = [];
  formData.goods.push()
  changePage(formData.page_id);
  loadDimension();
};

const edit = function(item) {
  start_stop_time.value = [formData.start_time, formData.stop_time]
  step.value = 1;
  formData.category_id = parseInt(item.category_id)
  formData.rules = item.rule;
  formData.dimension = []
  defaultExpanded.value = []
  for (let d of item.rule) {
    formData.dimension.push(d.dimension_id + ':' + d.dimension_name + ':' + d.dimension_field + ':' + d.cat_id + ':' + d.cat_name + ':' + d.dtype);
    defaultExpanded.value.push(d.cat_id)
  }
  if (item.selection_type === 2 && item.input_type === 1) {
    pagination.total = item.goods_count;
    pagination.pageSize = item.goods_count;
    pagination.page = 1;
    goodsMore(formData);
  }
  changePage(formData.page_id);
  changeSelectionType(formData.selection_type);
  loadDimension();
};

// 下一步
const onStep = function() {
  if (step.value == 1 && (formData.name == '' || formData.page_id == 0 || formData.area == '' || formData.start_time == '' || formData.stop_time == '')){
    ElMessage.error("请先填写必要参数！")
  } else if (step.value == 1 && formData.stop_time < formData.start_time) {
    ElMessage.error("结束时间不能早于开始时间！")
  } else{
    if (step.value == 2 && formData.selection_type == 1 && formData.dimension.length < 1) {
      ElMessage.error("请先选择维度指标！")
    } else if (step.value == 2 && formData.selection_type == 1) {
      changePositionType();
    }
    step.value += 1;
  }
};

// 栏位改变
const changePage = function(val) {
  if (val) {
    let page = config.page.find((p) => {
      return p.id == val;
    });
    thresholdLimit.value = page.threshold_limit;
    if (formData.threshold > thresholdLimit.value)
      formData.threshold = thresholdLimit.value;
    let _categoryTree = (category) => {
      let tree: Array<any> = []
      for (let c of category) {
        let t = {
          label: c.category_name,
          value: c.category_id,
        }
        if (c.children) {
          t['children'] = _categoryTree(c.children)
        }
        tree.push(t)
      }
      return tree
    }
    ApiService.get(apiUrl + '/category', {page: val}).then(({data}) => {
      if (data.area.length < 1) {
        ElMessage.error('基础数据不足，请与管理员联系！');
      } else {
        if (formData.id == 0) formData.area = data.area[0].name;
        config.area = [...data.area];
        config.category = _categoryTree(data.category);
        if (page.id == 1) {
          formData.category_id = 0;
          config.category = [];
        }
      }
    });
  }
};
// 投放类型改变
const changeSelectionType = function(val){
  if (val === 1) maxStep.value = 3;
  else maxStep.value = 2;
};

// 投放位置改变
const changePositionType = function() {
  let positions = {};
  for (let p of formData.goods) {
    if (p['id']) positions[p['goods_id']] = p;
  }
  formData.goods = [];
  loading.value = true;
  ApiService.get(apiUrl + '/selection_goods', formData).then(({data}) => {
    let i = 1;
    let goods = {};
    for (let d of data) {
      goods[d.goods_id] = d;
      if (positions[d.goods_id]) {
        formData.goods.push(positions[d.goods_id]);
      } else {
        formData.goods.push({
          goods_id: d.goods_id,
          position: i
        });
      }
      i += 1;
    }
    goodsData.value = goods;
    goodsTotal.value = i - 1;
    loading.value = false;
  });
};

// 上传提交
const submit = function (func) {
  let page = config.page.find((p) => {
    return p.id == formData.page_id;
  });
  if (formData.selection_type === 2 && formData.input_type == 1 && formData.goods.length == 0) {
    ElMessage.error("请输入商品id！");
    return false;
  }
  if (formData.selection_type===2 && formData.input_type == 2) {
    if ((enterGoodsRef as any).value.upload()) {
      callback.value = function() {
        filters.page_id = page.id;
        func();
      }
      return false;
    }else{
      filters.page_id = page.id;
      return true;
    }
  } else {
    filters.page_id = page.id;
    return true;
  }
};

// 查看结果弹层
const openResult = (r) => {
  dialogResult.value = true;
  result.value = r;
  for (let s of config.sorting_key) {
    if (r.sorting_key_id == s.key_id) {
      result.value.sorting_key_name = s.key_name;
    }
  }
  result.value.goods = [];
  pagination.total = result.value.goods_count;
  pagination.pageSize = 20;
  setCurrent(1);
};
// 查看结果分页
const setCurrent = (val) => {
  pagination.page = val;
  // result.value.goods = result.value.position.slice(
  //   (pagination.page - 1) * pagination.pageSize,
  //   pagination.page * pagination.pageSize >= pagination.total ? pagination.total : pagination.page * pagination.pageSize
  // );
  goodsMore(result.value);
};
// 载入更多
const goodsMore = (item) => {
  if (item.selection_type === 2) {
    ApiService.get(apiUrl + '/goods', {
      programme_id: item.id,
      offset: (pagination.page - 1) * pagination.pageSize,
      limit: pagination.pageSize
    }).then(({data}) => {
      item.goods = data.results;
      pagination.total = data.count;
      if (item.goods.length >= 200) {
        ElMessage.warning("载入商品数据过多会引起浏览器卡顿！！")
      }
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Datatable, {
      ref_key: "dataT",
      ref: dataT,
      apiUrl: apiUrl,
      "table-header": tableHeader.value,
      "enable-items-per-page-dropdown": true,
      data: _unref(formData),
      rules: rules,
      filters: _unref(filters),
      title: "商品推广配置",
      addAction: add,
      editAction: edit,
      step: step.value,
      maxStep: maxStep.value,
      submitAction: submit,
      delete: false
    }, {
      "table-top": _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: "为了确保栏位的整体效果，建议推广的商品数量低于栏位商品数量的10%",
          type: "info",
          "show-icon": "",
          closable: false
        })
      ]),
      "search-back": _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_el_radio_group, {
          modelValue: _unref(filters).page_id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).page_id) = $event)),
          size: "small",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (dataT.value.setCurrent(1)))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).page, (v) => {
              return (_openBlock(), _createBlock(_component_el_radio_button, {
                key: v.id,
                label: v.id,
                disabled: !v.is_active
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(v.name), 1)
                ]),
                _: 2
              }, 1032, ["label", "disabled"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_tooltip, {
          effect: "light",
          placement: "right"
        }, {
          content: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      "cell-threshold": _withCtx(({ row: r }) => [
        _createTextVNode(_toDisplayString(r.recommend_type === 1 ? '-' : r.threshold), 1)
      ]),
      "cell-user": _withCtx(({ row: r }) => [
        _createTextVNode(_toDisplayString(r.user.username), 1)
      ]),
      "actions-front": _withCtx(({ row: r }) => [
        _createElementVNode("div", {
          title: "查看结果",
          onClick: ($event: any) => (openResult(r)),
          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
        }, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
          ])
        ], 8, _hoisted_4)
      ]),
      form: _withCtx(() => [
        (_unref(formData).selection_type === 1)
          ? (_openBlock(), _createBlock(_component_el_steps, {
              key: 0,
              active: step.value - 1,
              "finish-status": "success",
              "align-center": "",
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_step, { title: "开始" }),
                _createVNode(_component_el_step, { title: "智能选品" }),
                _createVNode(_component_el_step, { title: "投放位置" }),
                _createVNode(_component_el_step, { title: "结束" })
              ]),
              _: 1
            }, 8, ["active"]))
          : _createCommentVNode("", true),
        (_unref(formData).selection_type === 2)
          ? (_openBlock(), _createBlock(_component_el_steps, {
              key: 1,
              active: step.value - 1,
              "finish-status": "success",
              "align-center": "",
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_step, { title: "开始" }),
                _createVNode(_component_el_step, { title: "投放位置" }),
                _createVNode(_component_el_step, { title: "结束" })
              ]),
              _: 1
            }, 8, ["active"]))
          : _createCommentVNode("", true),
        (step.value===1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_form_item, {
                label: "名称",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(formData).name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).name) = $event)),
                    placeholder: "请填写商品推广配置名称",
                    size: "small",
                    style: {"width":"400px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "栏位",
                prop: "page_id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(formData).page_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).page_id) = $event)),
                    placeholder: "请选择栏位页",
                    size: "small",
                    onChange: changePage
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).page, (v) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          value: v.id,
                          key: v.id,
                          label: v.name,
                          disabled: !v.is_active
                        }, null, 8, ["value", "label", "disabled"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "right"
                  }, {
                    content: _withCtx(() => [
                      _hoisted_7
                    ]),
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "区域",
                prop: "area"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(formData).area,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).area) = $event)),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).area, (v) => {
                        return (_openBlock(), _createBlock(_component_el_radio_button, {
                          key: v.name,
                          label: v.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(v.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_unref(config).category.length > 0)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "商品类目",
                    prop: "category_id"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_cascader, {
                        modelValue: _unref(formData).category_id,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).category_id) = $event)),
                        options: _unref(config).category,
                        props: { checkStrictly: true, emitPath: false },
                        placeholder: "请选择类目",
                        size: "small",
                        "collapse-tags": "",
                        style: {"width":"400px"}
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, {
                label: "选品类型",
                prop: "selection_type"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(formData).selection_type,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).selection_type) = $event)),
                    size: "small",
                    onChange: changeSelectionType
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, {
                        label: 1,
                        disabled: !_unref(config).config.selection_enabled
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_el_radio_button, { label: 2 }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (!_unref(config).config.selection_enabled)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "light",
                        placement: "right"
                      }, {
                        content: _withCtx(() => [
                          _hoisted_11
                        ]),
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_unref(formData).selection_type === 1)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "选品数量",
                    prop: "goods_count"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _unref(formData).goods_count,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).goods_count) = $event)),
                        modelModifiers: { number: true },
                        placeholder: "请填写数字",
                        min: 1,
                        max: 100000000,
                        size: "small"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(formData).selection_type === 1)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 2,
                    label: "选品排序",
                    prop: "sorting_key_id"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(formData).sorting_key_id,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formData).sorting_key_id) = $event)),
                        placeholder: "请选择选品的排序规则",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).sorting_key, (v) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              value: v.key_id,
                              key: v.key_id,
                              label: v.key_name
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, {
                label: "投放类型",
                prop: "recommend_type"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(formData).recommend_type,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formData).recommend_type) = $event)),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, { label: 1 }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: 2 }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "right"
                  }, {
                    content: _withCtx(() => [
                      _hoisted_15
                    ]),
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_unref(formData).recommend_type === 2)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 3,
                    label: "阈值",
                    prop: "threshold"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _unref(formData).threshold,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(formData).threshold) = $event)),
                        modelModifiers: { number: true },
                        placeholder: "请填写数字",
                        min: 1,
                        max: thresholdLimit.value,
                        size: "small"
                      }, null, 8, ["modelValue", "max"]),
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        placement: "right"
                      }, {
                        content: _withCtx(() => [
                          _hoisted_17,
                          _hoisted_18,
                          _hoisted_19
                        ]),
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, {
                label: "起止时间",
                prop: "start_stop_time"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: start_stop_time.value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((start_stop_time).value = $event)),
                    type: "datetimerange",
                    "range-separator": "到",
                    "value-format": "YYYY-MM-DD H:m:s",
                    size: "small",
                    "start-placeholder": "请输入开始时间",
                    "end-placeholder": "请输入结束时间",
                    clearable: false,
                    "append-to-body": false
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (step.value===2 && _unref(formData).selection_type===1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(SelectionRule, {
                apiUrl: apiUrl,
                config: _unref(config),
                data: _unref(formData),
                defaultExpanded: defaultExpanded.value
              }, null, 8, ["config", "data", "defaultExpanded"])
            ]))
          : _createCommentVNode("", true),
        (step.value===2 && _unref(formData).selection_type===2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(EnterGoodsId, {
                ref_key: "enterGoodsRef",
                ref: enterGoodsRef,
                apiUrl: apiUrl,
                data: _unref(formData),
                callback: callback.value,
                type: "position"
              }, null, 8, ["data", "callback"])
            ]))
          : _createCommentVNode("", true),
        (step.value===3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_el_form_item, {
                label: "投放位置",
                prop: "position_type"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(formData).position_type,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formData).position_type) = $event)),
                    size: "small",
                    onChange: changePositionType
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, { label: 1 }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: 2 }, {
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_unref(formData).position_type === 1)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode("当前时刻发现有" + _toDisplayString(goodsTotal.value) + "个商品，待正式使用时会略有不同。", 1)
                      ])), [
                        [_directive_loading, loading.value]
                      ]),
                      _hoisted_26,
                      _hoisted_27,
                      _createVNode(_component_el_input_number, {
                        modelValue: _unref(formData).initial,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(formData).initial) = $event)),
                        size: "small",
                        min: 1,
                        max: 10,
                        "controls-position": "right",
                        style: {"width":"80px"}
                      }, null, 8, ["modelValue"]),
                      _hoisted_28,
                      _createVNode(_component_el_input_number, {
                        modelValue: _unref(formData).interval,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(formData).interval) = $event)),
                        size: "small",
                        min: 1,
                        max: 100,
                        "controls-position": "right",
                        style: {"width":"80px"}
                      }, null, 8, ["modelValue"]),
                      _hoisted_29
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(formData).position_type === 2)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "",
                    prop: "goods"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode("当前时刻发现有" + _toDisplayString(goodsTotal.value) + "个商品，待正式使用时会略有不同。", 1)
                      ])), [
                        [_directive_loading, loading.value]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                        data: _unref(formData).goods,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            label: "商品图",
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              (goodsData.value[scope.row.goods_id])
                                ? (_openBlock(), _createBlock(_component_el_image, {
                                    key: 0,
                                    style: {"width":"60px"},
                                    src: goodsData.value[scope.row.goods_id]['goods_img'],
                                    "preview-src-list": [goodsData.value[scope.row.goods_id]['goods_img']]
                                  }, null, 8, ["src", "preview-src-list"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "goods_id",
                            label: "商品ID",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "位置",
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createVNode(_component_el_input_number, {
                                modelValue: scope.row.position,
                                "onUpdate:modelValue": ($event: any) => ((scope.row.position) = $event),
                                size: "small",
                                min: 1,
                                controls: false
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"])), [
                        [_directive_loading, loading.value]
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      btn: _withCtx(() => [
        (step.value > 1)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (step.value -= 1))
            }, {
              default: _withCtx(() => [
                _hoisted_30
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (step.value < maxStep.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (onStep()))
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-header", "data", "filters", "step", "maxStep"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogResult.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((dialogResult).value = $event)),
      title: "配置结果",
      width: "50%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_40, [
          _createVNode(_component_el_button, {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (dialogResult.value = false)),
            size: "small"
          }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { style: {"margin-top":"-40px","margin-bottom":"-50px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: [{title:'配置信息'}],
              style: {"width":"100%"},
              "show-header": false,
              "default-expand-all": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "title",
                  label: "配置信息",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, { type: "expand" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { style: {"padding-bottom":"15px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createTextVNode("名称： " + _toDisplayString(result.value.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createTextVNode("栏位： " + _toDisplayString(result.value.page.name), 1)
                          ]),
                          _: 1
                        }),
                        (result.value.page.name!=='首页')
                          ? (_openBlock(), _createBlock(_component_el_col, {
                              key: 0,
                              span: 6
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("类目： " + _toDisplayString(result.value.category_name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { style: {"padding-bottom":"15px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createTextVNode("选品类型： " + _toDisplayString(result.value.selection_type_name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createTextVNode("商品数： " + _toDisplayString(result.value.goods_count), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { style: {"padding-bottom":"15px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createTextVNode("投放类型： " + _toDisplayString(result.value.recommend_type_name), 1)
                          ]),
                          _: 1
                        }),
                        (result.value.recommend_type === 2)
                          ? (_openBlock(), _createBlock(_component_el_col, {
                              key: 0,
                              span: 6
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("阈值： " + _toDisplayString(result.value.threshold), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { style: {"padding-bottom":"15px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createTextVNode("开始时间： " + _toDisplayString(result.value.start_time), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createTextVNode("结束时间： " + _toDisplayString(result.value.stop_time), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (result.value.selection_type === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createVNode(_component_el_row, { style: {"padding-bottom":"15px"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _hoisted_33
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 8 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("投放位置： " + _toDisplayString(result.value.position_type_name), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 10 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("选品排序： " + _toDisplayString(result.value.sorting_key_name ? result.value.sorting_key_name : result.value.sorting_key_id), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.value.rule, (d) => {
                            return (_openBlock(), _createBlock(_component_el_row, {
                              key: d.dimension_id,
                              style: {"padding-bottom":"15px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: 22,
                                  offset: 2
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(d.cat_name) + " 类指标 " + _toDisplayString(d.dimension_name) + " " + _toDisplayString(dselect[d.dselect]) + " " + _toDisplayString(d.dvalue instanceof Array ? d.dvalue.join(' 和 ') : d.dvalue), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (result.value.selection_type === 2 && result.value.input_type === 2)
                      ? (_openBlock(), _createBlock(_component_el_row, {
                          key: 1,
                          style: {"padding-top":"20px","margin-bottom":"-10px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("共计上传了" + _toDisplayString(result.value.goods_count) + "个商品", 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_row, {
                          key: 2,
                          style: {"padding-top":"20px","margin-bottom":"-10px","font-weight":"bold"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_34
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (result.value.selection_type === 1 && result.value.position_type === 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 24,
                          style: {"text-align":"center"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_35,
                            _createElementVNode("span", _hoisted_36, _toDisplayString(result.value.initial), 1),
                            _hoisted_37,
                            _createElementVNode("span", _hoisted_38, _toDisplayString(result.value.interval), 1),
                            _hoisted_39
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table, {
                      data: result.value.goods,
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "goods_id",
                          label: "商品ID",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "position",
                          label: "位置",
                          align: "center"
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    _createVNode(_component_el_pagination, {
                      background: "",
                      layout: "prev, pager, next",
                      style: {"text-align":"center","margin-top":"5px"},
                      onCurrentChange: setCurrent,
                      "hide-on-single-page": true,
                      "current-page": _unref(pagination).page,
                      "page-size": _unref(pagination).pageSize,
                      total: _unref(pagination).total
                    }, null, 8, ["current-page", "page-size", "total"])
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})